import type { AttachmentBlock } from '../harness.types';

import type { ProjectAttachmentResponse } from './requests.types';

const attachmentTypeForMime = (mimeType: string): string =>
  mimeType.startsWith('image/') ? 'image' : 'file';

/** Build harness attachment blocks for the optimistic user bubble. */
export const projectAttachmentsToBlocks = (
  attachments: readonly ProjectAttachmentResponse[]
): AttachmentBlock[] =>
  attachments.map((attachment) => ({
    kind: 'attachment',
    attachment_id: attachment.id,
    filename: attachment.name,
    mime_type: attachment.type,
    attachment_type: attachmentTypeForMime(attachment.type),
    size_bytes: attachment.size ?? null,
  }));

/** Build attachment blocks from composer upload metadata before the turn POST. */
export const composerUploadMetadataToBlocks = (
  files: readonly {
    name: string;
    type: string;
    attachment_id: string;
  }[]
): AttachmentBlock[] =>
  files.map((file) => ({
    kind: 'attachment',
    attachment_id: file.attachment_id,
    filename: file.name,
    mime_type: file.type,
    attachment_type: attachmentTypeForMime(file.type),
    size_bytes: null,
  }));
